import { LiFiWidget, WidgetConfig, WidgetDrawer } from "@lifi/widget";
import Button from "app/components/button/button";
import { useTheme } from "app/shared";
import { getFeeByTier } from "app/utils/getFeeByTier";
import { FC, useEffect, useRef, useMemo, useState } from "react";

interface ILiFi {
  variant: "drawer" | "compact";
  integrator: string;
  tier?: string;
}

export const LiFi: FC<ILiFi> = ({ variant, integrator, tier }) => {
  const drawerRef = useRef<WidgetDrawer>(null);
  const { theme } = useTheme();
  const [isDrawerMounted, setIsDrawerMounted] = useState(false);
  const [shouldOpenDrawer, setShouldOpenDrawer] = useState(false);

  const config: WidgetConfig = useMemo(
    () => ({
      integrator: integrator,
      fee: getFeeByTier(tier),
      hiddenUI: ["poweredBy"],
      variant: variant,
      theme: {
        palette: {
          primary: { main: "#E90092" },
          secondary: { main: "#E90092" },
          background: {
            default: theme === "light" ? "#ffffff" : "#391368",
            paper: theme === "light" ? "#f8f8fa" : "#522f7d",
          },
          text: {
            primary: theme === "light" ? "#00070F" : "#ffffff",
            secondary: theme === "light" ? "#6A7481" : "#ffffffae",
          },
        },
        shape: {
          borderRadius: 10,
          borderRadiusSecondary: 8,
        },
        typography: {
          fontFamily: "Montserrat",
        },
        container: {
          padding: 20,
          ...(variant === "compact" && {
            borderRadius: 40,
            width: "100%",
            maxWidth: "100%",
          }),
        },
      },
    }),
    [variant, integrator, tier, theme]
  );

  useEffect(() => {
    if (!shouldOpenDrawer || !isDrawerMounted) return;

    drawerRef.current?.toggleDrawer();
    setShouldOpenDrawer(false);
  }, [isDrawerMounted, shouldOpenDrawer]);

  const toggleWidget = () => {
    if (!isDrawerMounted) {
      setIsDrawerMounted(true);
      setShouldOpenDrawer(true);
      return;
    }

    drawerRef.current?.toggleDrawer();
  };

  if (variant === "drawer") {
    return (
      <div>
        <Button variant="outlined" onClick={toggleWidget}>
          Onchain Swap
        </Button>
        {isDrawerMounted && (
          <LiFiWidget ref={drawerRef} config={config} integrator={integrator} />
        )}
      </div>
    );
  }

  return <LiFiWidget config={config} integrator={integrator} />;
};
